import React, { useState, Dispatch, SetStateAction } from 'react';
import {
  IconButton,
  IconButtonProps,
  Menu,
  MenuProps
} from '@material-ui/core';

type ChildFunction = (actions: {
  anchorEl: HTMLElement | null,
  setAnchorEl: Dispatch<SetStateAction<HTMLElement | null>>
}) => MenuProps['children']

export interface MenuIconButtonProps {
  icon: IconButtonProps['children']
  iconButtonProps?: IconButtonProps
  menuProps?: Partial<MenuProps>
  children?: MenuProps['children'] | ChildFunction
}

export const MenuIconButton = (props: MenuIconButtonProps) => {
  const {
    icon,
    iconButtonProps = {},
    menuProps = {},
    children
  } = props;

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <>
      <IconButton
        {...iconButtonProps}
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          setAnchorEl(e.currentTarget);
        }}>
        {icon}
      </IconButton>
      <Menu
        {...menuProps}
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={() => setAnchorEl(null)}
        onClick={e => {
          e.stopPropagation();
        }}
      >
        {(() => {
          if (typeof children === 'function') {
            return children({
              anchorEl,
              setAnchorEl
            });
          }

          if (children)
            return children;

          return '';
        })()}
      </Menu>
    </>
  );
};

export default MenuIconButton;
